import React, { useState, useEffect } from 'react';

const DynamicTime = () => {
  const [time, setTime] = useState('');

  useEffect(() => {
    const updateTime = () => {
      const currentTime = new Date();
      let hours = currentTime.getHours();
      let minutes = currentTime.getMinutes();
      let ampm = hours >= 12 ? 'PM' : 'AM';

      // Convert to 12-hour format
      if (hours > 12) {
        hours -= 12;
      }
      if (hours === 0) {
        hours = 12;
      }

      // Add leading zero to minutes if less than 10
      if (minutes < 10) {
        minutes = '0' + minutes;
      }

      const formattedTime = `${hours}:${minutes} ${ampm}`;
      setTime(formattedTime);
    };

    // Update time immediately on mount
    updateTime();

    // Set an interval to update the time every minute
    const intervalId = setInterval(updateTime, 60000);

    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className='font-inter text-[26px]'>
      {time}
    </div>
  );
};

export default DynamicTime;
